import { Component } from '@angular/core';

@Component({
  selector: 'Medical',
  templateUrl: './Medical.html',
  styleUrls: ['./Medical.css']
})
export class Medical {
   
}



// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/Medical/Medical.ts